import { LanguageProficiencyLevelModel } from '../../shared/models/language-proficiency-level-model';
import { JobseekerModel } from '../shared/models/jobseeker-model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobseekerLanguageModel } from '../shared/models/jobseeker-language-model';
import { WorldLanguageModel } from '@admin/shared/models/world-language-model';
import { JobseekerFile } from '@admin/jobseekers/shared/models/jobseeker-file';

@Component({
  selector: 'hr-jobseeker-language-info',
  templateUrl: './jobseeker-language-info.component.html',
  styleUrls: ['./jobseeker-language-info.component.less'],
  standalone: false,
})
export class JobseekerLanguageInfoComponent implements OnInit {
  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  public jobseeker: JobseekerModel;

  @Input()
  public languageproficiencyLevelList: LanguageProficiencyLevelModel[];
  @Input()
  public worldLanguages: WorldLanguageModel[];

  public newLanguage: JobseekerLanguageModel;
  public isAddModeOn: boolean;

  constructor() {
    this.isAddModeOn = false;
    this.newLanguage = null;
  }

  public onCancelLanguageEdit() {
    this.onUpdate.emit(false);
  }

  public onSaveLanguage() {
    this.onUpdate.emit(true);
  }

  onAddClick() {
    this.resetNewLanguage();
    this.isAddModeOn = true;
  }

  onCancelLanguageAdd() {
    this.isAddModeOn = false;
  }

  onLanguageAdded() {
    this.isAddModeOn = false;
    this.onUpdate.emit(true);
  }

  ngOnInit() {}

  private resetNewLanguage() {
    this.worldLanguages = this.worldLanguages.filter(
      (l) =>
        !this.jobseeker.languages.some(
          (ll) => ll.worldLanguage.worldLanguageId == l.worldLanguageId
        )
    );
    this.newLanguage = new JobseekerLanguageModel();
    this.newLanguage.jobseekerId = this.jobseeker.jobseekerId;
    this.newLanguage.jobseekerLanguageId = -1;
    this.newLanguage.worldLanguage = new WorldLanguageModel();
    this.newLanguage.languageProficiencyLevel =
      new LanguageProficiencyLevelModel();
    this.newLanguage.attachment = new JobseekerFile();
  }
}
